export default __webpack_public_path__ + "static/FrontDoor_Temp-e9e152c1a7ce0cc00d27ab55d6621c0e.webp";